import DatePickerComponent from "../../components/DatePickerComponent";
import { useSelector } from "react-redux";
import { selectAllCities } from "../common-states/commonStatesSlice";

const ReportingMenu = ({
  date,
  period,
  handlePeriodChange,
  handleEndDateChange,
  handleStartDateChange,
  handleSearch,
  handleGetExcel,
  setSelected,
  selected,
}) => {
  const allCities = useSelector(selectAllCities);

  const handleSelectChange = (e) => {
    let name = e.target.name;
    setSelected({ ...selected, [name]: e.target.value });
  };

  return (
    <div className="flex flex-wrap items-center gap-y-2">
      <div className="mr-auto flex items-stretch">
        <button
          className="mr-1 py-2 px-1 text-white text-xs bg-green-500 border-none rounded-md cursor-pointer"
          onClick={() => handleGetExcel(selected.waterType, selected.city)}
        >
          اکسل
        </button>
        <div className="relative">
          <select
            dir="rtl"
            name="waterType"
            value={selected.waterType}
            className="select-styles focus:shadow-focusShadow"
            onChange={handleSelectChange}
          >
            <option value="شرب و دام">شرب و دام</option>
            <option value="شرب انسان">شرب انسان</option>
            <option value="شرب دام">شرب دام</option>
          </select>
          <span className="double-select-arrow"></span>
        </div>
      </div>
      <div className="ml-auto flex justify-end items-center flex-wrap relative gap-y-3 border-y border-y-gray-300 py-3 w-full xl:w-max">
        <div className="box-hint absolute top-[-15px] right-0 bg-white px-1 text-xs text-gray-600">
          جستجو
        </div>
        <div className="flex gap-1">
          <button
            className="py-2 px-1 text-white text-xs bg-green-500 border-none rounded-md cursor-pointer"
            onClick={() =>
              handleSearch(
                selected.city && !selected?.region
                  ? `city_id=${selected.city}`
                  : selected.region && !selected.city
                    ? `region=${selected.region}`
                    : selected.city && selected.region
                      ? `region=${selected.region}&city_id=${selected.city}`
                      : "",
                selected.filter,
              )
            }
          >
            نمایش
          </button>
          <div className="flex gap-1">
            <input
              type="text"
              name="region"
              value={selected.region}
              className="focus:shadow-focusShadow select-styles "
              placeholder="نام منطقه را وارد کنید"
              onChange={handleSelectChange}
              dir="rtl"
              id="region"
            />
          </div>
          <div className="relative inline-block">
            <select
              dir="rtl"
              name="filter"
              value={selected.filter}
              className="select-styles focus:shadow-focusShadow"
              onChange={handleSelectChange}
            >
              <option value="همه">همه</option>
              <option value="تحویل شده">تحویل شده</option>
            </select>
            <span className="double-select-arrow"></span>
          </div>
          <div className="relative">
            <select
              dir="rtl"
              name="city"
              value={selected.city}
              className="select-styles focus:shadow-focusShadow"
              onChange={handleSelectChange}
            >
              <option value="">همه شهرها</option>
              {allCities.map((item, index) => {
                return (
                  <option key={index} value={item.city_id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
            <span className="double-select-arrow"></span>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-2 mx-1">
          <DatePickerComponent
            preSelected={date.endDate.toString()}
            handleChange={handleEndDateChange}
            label=":تا"
          />
          <DatePickerComponent
            preSelected={date.startDate.toString()}
            handleChange={handleStartDateChange}
            label=":از"
          />
        </div>
        <div className="flex">
          <div className="flex gap-1">
            <label htmlFor="month" className="ml-1 text-xs">
              ماه اخیر
            </label>
            <input
              type="radio"
              name="date"
              id="month"
              value="month"
              checked={period === "month"}
              onChange={handlePeriodChange}
            />
          </div>
          <div className="flex gap-1">
            <label htmlFor="week" className="ml-1 text-xs">
              هفته اخیر
            </label>
            <input
              type="radio"
              name="date"
              id="week"
              value="week"
              checked={period === "week"}
              onChange={handlePeriodChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportingMenu;
